import dayjs from 'dayjs';
import Cookies from 'js-cookie';
import DataTable from 'datatables.net-dt';
DataTable.ext.errMode = 'none';
import { swiper_update_height } from "../sliders/sliders.js";
import { getLanguageUrlPrefix } from "../helpers/translations.js";
import { translate } from "../helpers/translations.js";


/**
 * Корректировка округления десятичных дробей.
 * 
 * @param {String}  type  Тип корректировки.
 * @param {Number}  value Число.
 * @param {Integer} exp   Показатель степени (десятичный логарифм основания корректировки).
 * @returns {Number} Скорректированное значение.
 */
function decimalAdjust(type, value, exp) {
    // Если степень не определена, либо равна нулю...
    if (typeof exp === 'undefined' || +exp === 0) {
        return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // Если значение не является числом, либо степень не является целым числом...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
        return NaN;
    }
    // Сдвиг разрядов
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
    // Обратный сдвиг
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
}

// Ensure Math extensions only if they do not already exist
if (typeof Math.round10 !== 'function') {
    Math.round10 = function (value, exp) {
        return decimalAdjust('round', value, exp);
    };
}
if (typeof Math.floor10 !== 'function') {
    Math.floor10 = function (value, exp) {
        return decimalAdjust('floor', value, exp);
    };
}
if (typeof Math.ceil10 !== 'function') {
    Math.ceil10 = function (value, exp) {
        return decimalAdjust('ceil', value, exp);
    };
}


(async function ($) {
    // Use delegated events for dynamic elements
    $('body').on('input', '.payment-input', function () {
        updatePaymentInfo($(this));
    });

    function updatePaymentInfo($changed_input) {
        if (!$changed_input.length) {
            console.error('Error: changed input is not found');
            return;
        }
        let $payment_div = $changed_input.closest('.tab__transactions');
        if (!$payment_div.length) {
            console.error('Error: changed input is not in payment_div');
            return;
        }

        let $give_input = $payment_div.find('input.payment-input').first();
        let $get_input = $payment_div.find('input.payment-input').eq(1);

        let isYouLlGiveChanging = $give_input.is($changed_input);

        let inputForDecimal = isYouLlGiveChanging ? $get_input : $give_input;

        let payment_value = parseFloat($changed_input.val()) || 0;
        if (payment_value < 0) {
            payment_value = 0;
            $changed_input.val(0);
        }

        let decimalPlaces = parseInt(inputForDecimal.data('fix')) || 2;

        let $paymentDiv = $changed_input.closest('.one_payment_form__js');
        let $input_with_data = $paymentDiv.find('[name="currency"][data-cof]');
        let trade_type = $paymentDiv.find('[name="trade_type"]').val();

        var $cof = parseFloat($input_with_data.data('cof'));
        var $comission_value = parseFloat($input_with_data.data('value')) || 0;

        let result_value = calculateTradeValue(trade_type, payment_value, $cof, $comission_value, decimalPlaces, isYouLlGiveChanging);

        if (result_value !== undefined) {
            (isYouLlGiveChanging ? $get_input : $give_input).val(result_value);
        } else {
            console.error('Error: trade_type is not defined');
        }
    }

    function calculateTradeValue(trade_type, payment_value, cof, comission_value, decimalPlaces, isYouLlGiveChanging) {
        if (trade_type === 'receive') {
            if (isYouLlGiveChanging) {
                // Calculate the amount user will get
                let value = (payment_value * cof) - comission_value;
                return Math.max(0, Math.floor10(value, -decimalPlaces));
            } else {
                // Calculate how much user needs to give to get the desired amount
                let value = (payment_value + comission_value) / cof;
                return Math.max(0, Math.ceil10(value, -decimalPlaces));
            }
        } else if (trade_type === 'insert') {
            if (isYouLlGiveChanging) {
                // Calculate the amount user will get
                let value = (payment_value - comission_value) / cof;
                return Math.max(0, Math.floor10(value, -decimalPlaces));
            } else {
                // Calculate how much user needs to give to get the desired amount
                let value = payment_value  * cof + comission_value;
                return Math.max(0, Math.ceil10(value, -decimalPlaces));
            }
        }
        return undefined;
    }

    // Update currency change handler
    $('body').on('click', '.toggle-change-item', function (event) {
        let item = $(this);
        let toggle = item.closest('.toggle__hover');
        if (toggle && !item.hasClass('active')) {
            let input_name = item.data('input-name');
            let input_value = item.data('value-input');

            let currency = item.data('currency');
            if (currency) {
                let currency_span = toggle.closest('.one_payment_form__js').find('span.currency');
                currency_span.text(currency);
            }

            let input = toggle.closest('.one_payment_form__js').find(`input[name="${input_name}"]`);
            if (!input.length) {
                input = toggle.find(`input[name="${input_name}"]`);
            }

            let cof = item.data('cof');
            if (cof) {
                input.data('cof', cof);
            }

            input.val(input_value).change();

            let item_div = item.closest('.one_payment_form__js');
            if (item_div.length) {
                updatePaymentInfo(item_div.find('input.payment-input').first());
            }
        }
    });


    //on change of user_region
    $('input[name="user_region"]').on('change', function () {
        let selectedRegion = $(this).val();
        let $parent = $(this).closest('.pay_region');
        if ($parent.data('changed')) {
            return;
        }
        $parent.data('changed', true);
        // setTimeout(() => {
        //     $parent.data('changed', false);
        // }, 100);
        $('.pay_region').not($parent).find(`div[data-value-input='${selectedRegion}']:not(.active)`).click();

        $(`.payment_system li:not([data-regions*='${selectedRegion}'])`).hide();
        $(`.payment_system li[data-regions*='${selectedRegion}']`).show();
        Cookies.set("pay_region", selectedRegion, { expires: 30 });

        swiper_update_height();
        $parent.data('changed', false);
    });




    let deposit_svg = `<svg viewBox="0 0 13 13" width="13" height="13" fill="#c8c8c8" class="icon c-green item-svg" data-img="images/svg/deposit.svg">
                            <path d="M807.345,801.905c1.321,1.4,3.235,4.091,4.084,4.1a1.943,1.943,0,0,0,1.1-.853l2.1-2.162c0.3-.313.625-0.691,0.938-1.08,0.833-.985.318-1.875-0.386-1.843a1.57,1.57,0,0,0-1.159.8c-0.571.588-1.155,1.16-1.711,1.763a2.96,2.96,0,0,1-.773.8,3.66,3.66,0,0,1-1.049-1.023,14.052,14.052,0,0,0-2.373-2.332C807.093,799.7,806.663,801.154,807.345,801.905ZM814,807a2,2,0,0,1,0,4h-5a2,2,0,0,1,0-4s-0.589-2-1-2h-0.5a2.5,2.5,0,0,0-2.5,2.5v3a2.5,2.5,0,0,0,2.5,2.5h8a2.5,2.5,0,0,0,2.5-2.5v-3a2.5,2.5,0,0,0-2.5-2.5h-0.483C814.725,805,814,807,814,807Z" transform="translate(-805 -800)"></path>
                        </svg>`;
    let withdraw_svg = `<svg viewBox="0 0 13 13" width="13" height="13" fill="#c8c8c8" class="icon c-red item-svg" data-img="images/svg/withdraw.svg">
                                <path d="M932.655,805.1c-1.322-1.4-3.235-4.091-4.084-4.1a1.943,1.943,0,0,0-1.1.853q-1.048,1.082-2.1,2.161c-0.3.314-.625,0.692-0.938,1.081-0.833.985-.319,1.875,0.386,1.843a1.57,1.57,0,0,0,1.159-.8c0.571-.588,1.155-1.16,1.711-1.764a2.99,2.99,0,0,1,.773-0.8,3.676,3.676,0,0,1,1.049,1.024,14.129,14.129,0,0,0,2.373,2.332C932.907,807.3,933.337,805.846,932.655,805.1ZM935,808.5v3a2.5,2.5,0,0,1-2.5,2.5h-8a2.5,2.5,0,0,1-2.5-2.5v-3c0-1.381,2,.395,2,1.5a2,2,0,0,0,2,2h5a2,2,0,0,0,2-2C933,808.9,935,807.119,935,808.5Z" transform="translate(-922 -801)"></path>
                            </svg>`;
    let exchange_svg = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13"  fill="#c8c8c8" class="icon c-main item-svg" data-img="images/svg/exchange.svg">
      <path id="exchange" style=" fill-rule: evenodd;" d="M417.345,12.9c1.322,1.4,2.235,3.091,3.084,3.1a1.943,1.943,0,0,0,1.1-.853c0.7-.72.4-0.441,1.1-1.161,0.3-.313.625-0.692,0.938-1.081,0.833-.985.319-1.874-0.386-1.843a1.569,1.569,0,0,0-1.159.8c-0.571.588-.155,0.16-0.711,0.763a2.97,2.97,0,0,1-.773.8,3.666,3.666,0,0,1-1.049-1.024,4.546,4.546,0,0,0-1.373-1.332C417.093,10.7,416.663,12.154,417.345,12.9Zm-1.66.191c-1.328-1.4-2.246-3.091-3.1-3.1a1.949,1.949,0,0,0-1.109.853c-0.7.72-.4,0.441-1.1,1.161-0.305.313-.628,0.692-0.942,1.081-0.837.985-.32,1.874,0.388,1.843a1.575,1.575,0,0,0,1.164-.8c0.573-.588.156-0.16,0.714-0.763a2.979,2.979,0,0,1,.777-0.8,3.68,3.68,0,0,1,1.053,1.024,4.552,4.552,0,0,0,1.38,1.332C415.938,15.3,416.369,13.846,415.685,13.1Zm7.022,3.229A2.489,2.489,0,0,1,423,17.5v3a2.5,2.5,0,0,1-2.5,2.5h-8a2.5,2.5,0,0,1-2.5-2.5v-3a2.5,2.5,0,0,1,.279-1.15c0.694,0.515.821,0.624,2.037,1.571A2,2,0,0,0,414,21h5a2,2,0,0,0,2-2,2.508,2.508,0,0,0-.584-1.412C421.1,17.2,421.986,16.738,422.707,16.325Z" transform="translate(-409 -10)"/>
    </svg>`;

    let langPrefix = getLanguageUrlPrefix();
    $(document).on('preInit.dt', function (e, settings) {
        $('.dt-search').parent('.dt-layout-cell').parent('.dt-layout-row').addClass('search-row');
        $('.dt-paging').parent('.dt-layout-cell').parent('.dt-layout-row').addClass('pagination-row').hide();
    });
    let history_table_url = '/engine/function/payments_history_loader.php';
    let history_table = new DataTable(`.main [data-action="${history_table_url}"] table`, {
        ajax: history_table_url,
        processing: true,
        drawCallback: function (settings) {
            table_add_dark_light(history_table);
            swiper_update_height();
        },
        language: {
            url: `/template/js/lib/datatables/${langPrefix}.json`
        },
        serverSide: true,
        searching: false,
        ordering: false,
        columns: [
            {
                data: 'show_type',
                className: 'show-type',
                orderable: false,
                render: function (data, type, row) {
                    switch (data) {
                        case 'Input':
                            return deposit_svg;
                        case 'Output':
                            return withdraw_svg;
                        case 'Exchange':
                            return exchange_svg;
                        default:
                            return withdraw_svg;
                    }
                }
            },
            {
                data: 'id',
                render: function (data, type, row) {
                    return `<span js-copy>${data}</span>`;
                }

            },
            {
                data: 'value',
                render: function (data, type, row) {
                    return `<span class="${row.color_str_class}">${data}</span>`;
                }
            },
            {
                data: 'show_status',
                orderable: false,
                render: function (data, type, row) {
                    return `<span class="${row.color_str_class}">${data}</span>`;
                }
            },
            {
                data: 'timestamp',
                render: function (data, type, row) {
                    return dayjs.unix(data).format("YYYY.MM.DD HH:mm");
                }
            },
            {
                data: null,
                orderable: false,
                render: function (data, type, row) {
                    return `<div class="toggle-tr-details">
                            ${row.payment_system_icon ? `<img src="${row.payment_system_icon}" alt="" class="icon ${row.payment_system_icon.includes('market4pro') ? 'colored' : ''}">` : ''}
                            <span>${row.payment_system_show} ${row.value_in_currency && row.currency ? ` – ${row.value_in_currency} ${row.currency}` : ''}</span>
                            <span class="toggle-arrow min absolute"></span>
                        </div>`;
                }
            }
        ],
        order: [],
        "createdRow": function (row, data, dataIndex) {
            $(row).addClass(`js-toggle-tr toggle`);
            $(row).attr('data-toggle', data.id);
        },
        "initComplete": function (settings, json) {
            $(`[data-action="${history_table_url}"]`).find('.pagination-row').show();   
            swiper_update_height();
        }

    });



    // Formatting function for row details - modify as you need
    function format(d) {
        // `d` is the original data object for the row
        if (!d.details_hide) {
            return `
                        <div class="toggle-hidden hide">
                            <div class="toggle-tr-hide-wrap">
                                <div class="flex-ac flex-jsb">
                                    <div class="flex-ac">
                                        <div class="wording">
                                            <span>error:<b> no details</b><span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
            `;
        }
        let data = d.details_hide;
        let response = `<div class="toggle-hidden hide">
                            <div class="toggle-tr-hide-wrap">
                                <div class="flex-ac flex-jsb">
                                    <div class="flex-ac">
                        `;
        for (let [key, value] of Object.entries(data)) {
            if (key == 'total_items' || key == 'total_items_value' || key == 'answer_to_user' || key == 'total_in' || key == 'total_out') {
                //skip these values
                continue;
            }
            if (value.title && value.value) {
                response += `<div class="wording text-al">`
                if (value.icon) {
                    response += `<img src="${value.icon}" alt="" class="icon">`;
                }
                response += `  <span>${value.title}: <b ${value.title == "Protection code" ? "js-copy" : ""}>${value.value}</b></span>
                            </div>`;
            }
        }

        //close flex-ac
        response += `</div>`;

        if (data.total_items && data.total_items_value) {
            response += `<div class="wording text-al mr-0">
                            <span>${data.total_items.title}: <b>${data.total_items.value} (${data.total_items_value.value})</b></span>
                        </div>`;
        }
        if (data.total_in && data.total_in.value) {
            response += `<div class="wording text-al mr-0">
                            <span>${translate('In')}: ${data.total_in.value}</span>
                        </div>`;
        }
        response += `</div>`;


        //div for answer_to_user
        if (data.answer_to_user && data.answer_to_user.title && data.answer_to_user.value) {
            response += `<div class="flex-ac flex-jsb">
                            <div class="flex-ac">
                                <div class="wording text-al">
                                    <span>${data.answer_to_user.title}: <b>${data.answer_to_user.value}</b></span>
                                </div>
                            </div>
                        </div>`;
        }


        if (data.items && data.items.value) {
            response += `<div class="table-td-info">`;
            response += data.items.value;
            response += `</div>`;
        }
        
        if (data.items_out && data.items_out.value) {
            if (data.total_out && data.total_out.value) {
                response += `<div class="flex-ac flex-jsb">
                                    <div class="flex-ac">
                                    </div>
                                        <div class="wording text-al mr-0">
                                            <span>${translate('Out')}: ${data.total_out.value}</span>
                                        </div>
                            </div>`;
            }
            response += `<div class="table-td-info">`;
            response += data.items_out.value;
            if (!data.items || !data.items.value) {
                response += `</div>`;
            }
        }
        response += `</div></div>`;

        return response;
    }

    // Add event listener for opening and closing details
    $('body').on('click', 'tr[data-toggle]:not([data-dt-row])', function (e) {
        if ($(e.target).closest('[js-copy]').length || $(e.target).closest('button[type="submit"]').length) {
            return true;
        }
        let tr = e.target.closest('tr');
        let row = history_table.row(tr);

        if (row.child.isShown()) {
            // This row is already open - close it
            // $('div.slider', row.child()).slideUp(500, function () {
            //     $(tr).find('.show-type').attr('rowspan', '1');
            //     row.child.hide();
            // } );
            setTimeout(() => {
                $(tr).find('.show-type').attr('rowspan', '1');
                row.child.hide();
            }, 500);

        }
        else {
            // Open this row
            $(tr).find('.show-type').attr('rowspan', '2');
            row.child(format(row.data()), `js-toggle--appeared-tr js-toggle-tr toggle-tr-hide toggle-hidden hide ${$(tr).hasClass('dark') ? 'dark' : 'light'}`).show();
            $(row.child()).attr('data-toggle', row.data().id);
            //$('div.slider', row.child()).slideDown(500);
        }
    });




    function table_add_dark_light(datatable) {
        let trs = datatable.rows(':not(js-toggle--appeared-tr)', {
            search: 'applied',
            order: 'current'
        }).nodes();

        $(trs).each(function (i, tr) {
            $(tr).removeClass('dark light');
            $(tr).addClass(i % 2 ? 'light' : 'dark');
        });
    }


})(jQuery);